import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'daysLeft',
    pure: true,
    standalone: false
})
export class DaysLeftPipe implements PipeTransform {
  constructor() {}

  transform(item: any): string | null {
    if (!item) {
      return null;
    }

    const currentDate = new Date();
    const activeToDate = new Date(item);

    const diffInTime = activeToDate.getTime() - currentDate.getTime();
    const diffInDays = Math.ceil(diffInTime / (1000 * 3600 * 24));

    if (diffInDays > 0) {
      return `${diffInDays}`;
    } else {
      return '0';
    }
  }
}
